export const parseJwt = (token?: string) => {
  if (!token) throw Error('No token provided');

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
  } catch {
    throw Error('Failed to parse token');
  }
};
